import React from "react";
import { Button, Tag, Tooltip } from "@netapp/bxp-design-system-react";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";
import styles from "./RoleTag.module.scss";

const RoleTag = ({ name, description, onClose, closeDisabled = false, closeLabel }) => (
    <Tag className={styles.tag} style={{ display: "inline-flex", alignItems: "center", padding: (onClose || closeDisabled) ? "0 4px 0 12px" : "0 12px" }}>
        <span className={styles.label}>{name}</span>
        {description ? <Tooltip>{description}</Tooltip> : null}
        {(onClose || closeDisabled) && (
            <Button
                variant="icon"
                className={styles.close}
                aria-label={closeLabel || name}
                disabled={closeDisabled}
                onClick={(event) => {
                    event.stopPropagation();
                    if (!closeDisabled && onClose) {
                        onClose();
                    }
                }}
            >
                <CloseIcon />
            </Button>
        )}
    </Tag>
);

export default RoleTag;
